/** @format */
import { ChangeDetectionStrategy, Component, computed, EventEmitter, inject, input, Output, ViewEncapsulation } from '@angular/core';
import { CreditRange, CustomModuleAttainment, OtmId } from 'common-typescript/types';
import { CustomModuleAttainmentStateObject } from '../../service/plan-state.service';
import { Action } from '../../study-boxes/study-action-box/study-action-box.component';
import { StudyBoxType } from '../../study-boxes/study-box/study-box.component';
import { PlanStructureContext } from '../plan-structure-context';

@Component({
    selector: 'sis-plan-structure-custom-module-attainment-box',
    templateUrl: './plan-structure-custom-module-attainment-box.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class PlanStructureCustomModuleAttainmentBoxComponent {
    readonly customModuleAttainment = input.required<CustomModuleAttainment>();
    readonly headingLevel = input.required<number>();
    readonly selected = input<boolean>();
    readonly action = input<Action>();
    @Output() actionChange? = new EventEmitter<OtmId>();

    private readonly planStructureContext = inject(PlanStructureContext);

    protected readonly customModuleAttainmentStateObject = computed<CustomModuleAttainmentStateObject | undefined>(
        () => this.planStructureContext.planStateObject().customModuleAttainments?.[this.customModuleAttainment()?.id],
    );
    protected readonly visibleCredits = computed<CreditRange | undefined>(() => {
        const customModuleAttainment = this.customModuleAttainment();
        return customModuleAttainment ? { min: customModuleAttainment.credits, max: customModuleAttainment.credits } : undefined;
    });
    readonly studyBoxType = StudyBoxType.customModuleAttainment;
}
